<template>
    <div>
    <b-col v-show="addNewKafala" md="12">
      
      <b-card
        :title="form.id ? 'تعديل بيانات الكفالة' : 'اضافة الكفالة الجديدة'"
        class="text-left"
      >
        <!-- <b-card-text>
        </b-card-text> -->
        <b-row class="mb-2">
          <b-col md="4">
            <b-form-input
              v-model="form.name"
              placeholder="اسم المكفول"
            />
      </b-col>
      <b-col  md="4">
        <b-form-group>
          <v-select
            v-model="form.department_id"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="ar_name"
            :options="search.departments"
            placeholder="مكان عمل المكفول"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
            <b-form-input
              v-model="form.kafala_no"
              placeholder="رقم الكفالة"
            />
      </b-col>
      <b-col md="4">
              <b-form-group>
                <cleave
                  id="date"
                  v-model="form.date"
                  class="form-control"
                  :raw="false"
                  :options="date"
                  placeholder="تاريخ الكفالة YYYY-MM-DD"
                />
              </b-form-group>
            </b-col>
      <b-col md="4">
        <cleave
          id="number"
          v-model="form.amount"
          class="form-control"
          :raw="false"
          :options="format.price"
          placeholder="مبلغ الكفالة"
        />
  </b-col>
  <b-col md="4">
            <b-form-file
              placeholder="اختر ملف المعاملة..."
              drop-placeholder="اختر الملف او اسقطها هنا..."
              ref="file"
              v-model="form.file"
              @change="selectFiles"
            />
          </b-col>
      <b-col  md="4">
        <b-form-group>
          <b-form-textarea
              id="input-invalid1"
              placeholder="الملاحظات"
              v-model="form.notes"
                rows="1"
            />
        </b-form-group>
      </b-col>
      
        </b-row>
        <b-row v-show="form.id !=null"
          v-for="(item, index) in form.kafels"
          :id="item.id"
          :key="item.id"
          ref="row"
        >

          <!-- Item Name -->
          <b-col md="4">
            <b-form-group
            >
              <b-form-input
                id="item-name"
                type="text"
                placeholder="اسم الكفيل الكامل"
                v-model="item.name"
                :disabled="form.id?true:false"
              />
            </b-form-group>
          </b-col>

          <!-- Cost -->
          <b-col md="4">
            <b-form-group
>
          <v-select
            v-model="item.department"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            label="ar_name"
            :options="search.departments"
            placeholder="مكان عمل الكفيل"
            :disabled="form.id?true:false"
            />
        </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="4"
            md="4"
          >
          <!-- <b-row> -->
            <b-button v-show="form.kafels.length >= 1 "
            style="margin-left: 10px;"
              variant="outline-danger"
              @click="deleteItem(item.id,item.kafel_id)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>حذف الكفيل</span>
            </b-button>

          <!-- </b-row> -->
          </b-col>
          
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        <b-row
          v-for="(item, index) in repeaters"
          :id="item.id"
          :key="item.id"
          ref="row"
        >

          <!-- Item Name -->
          <b-col md="4">
            <b-form-group
            >
              <b-form-input
                id="item-name"
                type="text"
                placeholder="اسم الكفيل الكامل"
                v-model="item.name"
              />
            </b-form-group>
          </b-col>

          <!-- Cost -->
          <b-col md="4">
            <b-form-group
>
          <v-select
            v-model="item.department"
            dir="rtl"
            label="ar_name"
            :options="search.departments"
            placeholder="مكان عمل الكفيل"
            />
        </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="4"
            md="4"
          >
          <!-- <b-row> -->
            <b-button v-show="repeaters.length >= 2"
            style="margin-left: 10px;"
              variant="outline-danger"
              @click="removeItem(index)"
            >
              <feather-icon
                icon="XIcon"
                class="mr-25"
              />
              <span>حذف الكفيل</span>
            </b-button>
            <b-button
              variant="outline-success"
              @click="repeateAgain"
              >
              <feather-icon
              icon="PlusIcon"
              class="mr-25"
            />
              <span>اضافة كفيل اخر</span>
            </b-button>

          <!-- </b-row> -->
          </b-col>
          
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
        <b-row>
          <b-button
              @click="handleSubmit()"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
                class="mr-50"
              >
              <feather-icon
              :icon="form.id ? 'EditIcon' : 'PlusIcon'"
              class="mr-50"
              />
                <span class="align-middle">{{ form.id ? 'تحديث بيانات الكفالة' : 'اضافة الكفالة الجديدة' }}</span> 
              </b-button>
          <b-button
              @click="resetForm(true)"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="secondary"
              >
                <span class="align-middle">{{ form.id?'الغاء التعديل الكفالة':'استمارة جديدة' }}</span> 
              </b-button>
        </b-row>
      </b-card>
  </b-col>
    <b-card-code
        title="المكفولين"
        no-body
      >
      <b-row style="margin: 10px">
          <b-col md="4">
                  <b-form-input
                    v-model="search.title"
                    placeholder="بحث عن طريق اسم المكفول او رقم الكفالة"
                  />
            </b-col>
            <b-col  md="4">
              <b-form-group>
                <v-select
                  v-model="search.department_id"
                  dir="rtl"
                  label="ar_name"
                  :options="search.departments"
                  placeholder=" مكان عمل الكفيل"
                />
              </b-form-group>
            </b-col>
            <b-col md="3">
                <b-button
              @click="addNewKafalaStatus()"
                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                variant="primary"
              >
              <feather-icon
              icon="PlusIcon"
              class="mr-50"
              />
                <span class="align-middle">اضافة كفالة جديد</span> 
              </b-button>
            </b-col>
            <b-col md="2">
                    <b-form-checkbox-group
              id="checkbox-group-2"
              name="flavour-2"
              class="demo-inline-spacing"
              v-model="finishedItems"
              @change="gS()"
            >
              <b-form-checkbox :value="true"> الكفالات المرحلة </b-form-checkbox>
            </b-form-checkbox-group>
            </b-col>
        </b-row>
        <div>
          <div class="demo-vertical-spacing">
      <b-progress v-if="precentage !== 0" :value="precentage" max="100" />
    </div>
          <b-table
            :items="items"
            :fields="fields"
            striped
            responsive
            class="mb-0"
          >
            <template #cell(show_details)="row">
              <b-form-checkbox
                v-model="row.detailsShowing"
                
                @change="row.toggleDetails"
              >
                {{ row.detailsShowing ? 'اخفاء التفاصيل' : 'عرض التفاصيل' }}
              </b-form-checkbox>
            </template>
    
            <!-- full detail on click -->
            <template #row-details="row">
              <b-card>
                <b-row class="mb-2">
                  <b-col
                    md="4"
                    class="mb-1"
                  >
                    <strong>رقم الكفالة : </strong>{{ row.item.kafala_no }}
                  </b-col>
                  <b-col
                    md="4"
                    class="mb-1"
                  >
                    <strong>مبلغ الكفالة : </strong>{{ row.item.amount }}
                  </b-col>
                  <b-col
                    md="4"
                    class="mb-1"
                  >
                    <strong>تاريخ الكفالة : </strong>{{ row.item.date }}
                  </b-col>
                  <b-col 
                    md="4"
                    class="mb-1"
                  >
                    <strong>الكفلاء : </strong>
                    <p v-for="(kafel,index) in row.item.kafels"
                    :key="kafel.id">

                    {{index+1}}- {{ kafel.name }} من {{ kafel.department.ar_name }}  
                    </p>
                  </b-col>
                  <b-col v-if="row.item.notes!=null && row.item.notes!=''&& row.item.notes!='null'"
                    md="4"
                    class="mb-1"
                  >
                    <strong>الملاحظات : </strong>{{ row.item.notes }}
                  </b-col>
                </b-row>
    
                <b-button style="margin-left: 10px;"
                  size="sm"
                  variant="outline-primary"
                  @click="editKafala(row.item,true)"
                >
                  تعديل بيانات الكفالة
                </b-button>
                <b-button style="margin-left: 10px;"
                  size="sm"
                  variant="outline-danger"
                  v-b-modal.model-delete-kafala
                  @click="editKafala(row.item,false)"
                >
                  حذف الكفالة
                </b-button>
                <b-button style="margin-left: 10px;"
                  size="sm"
                  variant="outline-success"
                  v-b-modal.model-completed-kafala
                  @click="editKafala(row.item,false)"
                >
                  ترحيل المعاملة
                </b-button>
                <b-button v-if="row.item.file!=null && row.item.file!=''&& row.item.file!='null'" style="margin-left: 10px;"
                  size="sm"
                  variant="outline-warning"
                  @click="showPfd(row.item.file)"
                >
                  عرض ملف الكفالة
                </b-button>
                <b-button style="margin-left: 10px;"
                  size="sm"
                  variant="outline-secondary"
                  @click="row.toggleDetails"
                >
                  اخفاء البيانات
                </b-button>
              </b-card>
            </template>
    
            <template #cell(avatar)="data">
              <b-avatar :src="data.value" />
            </template>
    
            <template #cell(year)="data">
              <p>
                  {{data.item.year.begin}} - {{data.item.year.end}}
              </p>
                
            </template>
            
    <template #cell(status)="data">
      <b-badge 
      v-if="data.item.is_done==1"
      pill
      :variant="success"
    >
      كفالة مرحلة
    </b-badge>
    <b-badge v-else
      pill
      :variant="waiting"
    >
      كفالة غير مرحلة
    </b-badge>
  </template>
          </b-table>
          <b-row style="padding: 20px;">
              <b-col md="11">
                  <b-pagination
                  v-model="currentPage"
                  :total-rows="totalRows"
                  :per-page="perPage"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  class="mb-0"
                  @change="check()"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </b-col>
              <b-col md="1">
                  <b-form-select
                  id="perPageSelect"
                  v-model="perPage"
                  @change="check()"
                  size="sm"
                  inline
                  :options="pageOptions"
                />
              </b-col>
          </b-row>
        </div>
        <b-modal
            id="model-delete-kafala"
            centered
            title="حذف الكفالة"
            @ok="deleteKafala"
            ok-title="حذف الحقل"
          >
            <b-card-text>
              هل تريد حذف هذه الحقل  " {{ this.form.name }} "
              ؟
            </b-card-text>
          </b-modal>
        <b-modal
            id="model-completed-kafala"
            centered
            title="ترحيل الكفالة"
            @ok="completeKafala"
            ok-title="موافق"
          >
            <b-card-text>
              هل تريد ترحيل هذه الحقل  " {{ this.form.name }} "
              ؟
            </b-card-text>
          </b-modal>
      </b-card-code>
    </div>
    
    </template>
    
    <script>
    import Ripple from "vue-ripple-directive";
  import BCardCode from '@core/components/b-card-code/BCardCode.vue'
  import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
  import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
  import Cleave from "vue-cleave-component";
import "cleave.js/dist/addons/cleave-phone.us";
import { filesUrl } from "@/main.js";
  import {
      BTable, BFormCheckbox,BFormTextarea,
    BTabs,BFormRow,BForm,VBModal,BFormFile,BProgress,
    BTab,BFormInput,BPagination,BFormCheckboxGroup,BFormSelect, BFormGroup, BButton, BCard, BRow, BCol, BAvatar, BBadge,BModal,
    } from 'bootstrap-vue'
  import vSelect from "vue-select";
    export default {
      components: {
        BCardCode,BFormRow,
        BTable,Ripple,BForm,Cleave,
        BTabs,AppTimeline,BProgress,
        BTab,AppTimelineItem,BModal,
        BButton,BPagination,
        BFormCheckbox,BFormTextarea,
        BCard,BFormGroup,VBModal,
        BRow,vSelect,BFormInput,
        BCol,BFormSelect,
        BFormCheckboxGroup,
        BBadge,filesUrl,
        BAvatar,BFormFile
      },
      directives: {
      Ripple,
    },
      data() {
        return {
          precentage: 0,
          success: 'success',
          waiting: 'warning',
          danger: 'danger',
          finishedItems:false,
          repeaters: [{
            id: 1,
            name: '',
            department: '',
          }],
      nextTodoId: 2,
          totalRows: 1,
          currentPage: 0,
          perPage: 3,
          addNewKafala:false,
          date: {
            date: true,
            delimiter: "-",
            datePattern: ["Y", "m", "d"],
          },
      format:{
        price: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
        },
        number: {
          creditCard: true,
        },
      },
          form:{
            name:null,
            department_id:null,
            kafala_no:null,
            amount:null,
            date:null,
            is_done:null,
            notes:null,
            file:null,
            kafels:[]
          },
          editForm:{
            id:null,
            name:null,
            department_id:null,
            kafala_no:null,
            amount:null,
            date:null,
            is_done:null,
            notes:null
          },
          statuses:[],
          status:{
            id:null,
            stdinf_id:null,
            year:null,
            year_id:null,
            stage:null,
            stage_id:null,
            department:null,
            department_id:null,
            type:null,
            type_id:null,
            status:null,
            status_id:null,
            old_status:null
          },
          pageOptions: [3, 5, 10, 100],
          fields: [
              { key: 'show_details', label: 'عرض البيانات' }, 
              { key: 'name', label: 'اسم الموظف' }, 
              { key: 'department.ar_name', label: 'القسم' },
              { key: "status",label: "حالة الطلب"},
          ],
          items: [],
          search:{
              title:"",
              departments:[],
              years:[],
              stages:[],
              types:[],
              statuses:[],
              countries:[],
              cities:[],
              genders:[],
              branchs:[],
              windows:[],
              accepttypes:[],
              department_id:null,
              year_id:null,
              stage_id:null,
              type_id:null,
              status_id:null,
          },
          department_id:null,
          year_id:null,
          stage_id:null,
          type_id:null,
          status_id:null,
        }
      },
      watch: {
        "search.title": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      "search.department_id": function (val) {
        if (val != null && val != "") {
          this.gS();
        }
      },
      },
      mounted() {
        this.gS(),this.gSM(),this.initTrHeight()
      },
      created() {
        window.addEventListener('resize', this.initTrHeight)
      },
      destroyed() {
        window.removeEventListener('resize', this.initTrHeight)
      },
      methods: {
        async completeKafala(){
          await this.axios
            .get(`kafel/Completed/${this.form.id}`,{
          onUploadProgress: (progressEvent) => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          },
        })
            .then((res) => {
              if (res.data.errors) {
                this.errorToast();
              } else {
                this.makeToast(
                  "success",
                  "اتمام الكفالة",
                  "تم اتمام العنصر بنجاح"
                );
                this.resetForm(false);
                this.gS();
                }
                this.precentage = 0;
            })
            .catch((e) => {
              if (e.message.includes("401")) {
                this.makeToast(
                  "warning",
                  "فشل الانجاز",
                  "لقد فشلت عملية الانجاز للعنصر ;)"
                );
              } else {
                this.errorToast();
              }
              this.precentage = 0;
            })
        },
        async deleteKafala(){
          await this.axios
            .delete(`kafel/${this.form.id}`)
            .then((res) => {
              if (res.data.errors) {
                this.errorToast();
              } else {
                this.makeToast(
                  "success",
                  "خذف عنصر",
                  "تم حذف العنصر بنجاح"
                );
                this.resetForm(false);
                this.gS();
                }
            })
            .catch((e) => {
              if (e.message.includes("401")) {
                this.makeToast(
                  "warning",
                  "فشل الخذف",
                  "لقد فشلت عملية الحذف للعنصر ;)"
                );
              } else {
                this.errorToast();
              }
            })
        },
        async deleteItem(id,kafel_id){
          await this.axios
            .delete(`kufala/${id}`,{
          onUploadProgress: (progressEvent) => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          },
        })
            .then((res) => {
              if (res.data.errors) {
                this.errorToast();
              } else {
                this.makeToast(
                  "success",
                  "خذف عنصر",
                  "تم حذف العنصر بنجاح"
                );
                this.getKafels(kafel_id);
                }
                this.precentage = 0;
            })
            .catch((e) => {
              if (e.message.includes("401")) {
                this.makeToast(
                  "warning",
                  "فشل الخذف",
                  "لقد فشلت عملية الحذف للعنصر ;)"
                );
              } else {
                this.errorToast();
              }
              this.precentage = 0;
            })
        },
        scrollUp() {
          window.scrollTo({
            top: 0,
            behavior: 'smooth',
            block: 'start',
            inline: 'start'
          });
        },
        async getKafels(id){
          await this.axios
            .get(`kafel/show/${id}`)
            .then((res) => {
              if (res.data.errors) {
                this.errorToast();
              } else {
                this.form.kafels = res.data.kafels;
              }
            })
            .catch((e) => {
              if (e.message.includes("401")) {
                this.makeToast(
                  "warning",
                  "فشل الخذف",
                  "لقد فشلت عملية الحذف للعنصر ;)"
                );
              } else {
                this.errorToast();
              }
            })
        },
        editKafala(item,status){
          this.form.id=item.id,
            this.form.name=item.name,
            this.form.department_id=item.department,
            this.form.kafala_no=item.kafala_no,
            this.form.amount=item.amount,
            this.form.date=item.date,
            this.form.is_done=item.is_done,
            this.form.notes=item.notes,
            this.form.kafels=item.kafels,
            this.form.file=item.file,
            this.addNewKafala=status
            console.log(item.file)
            this.scrollUp()
        },
        repeateAgain() {
          this.repeaters.push({
            id: this.nextTodoId,
            name: '',
            department_id: '',
          })
          this.nextTodoId += 1

          this.$nextTick(() => {
            if (this.$refs.row && this.$refs.row.length > 0) {
              this.trAddHeight(this.$refs.row[0].offsetHeight)
            }
          })
        },
        removeItem(index) {
          this.repeaters.splice(index, 1)
          this.$nextTick(() => {
            if (this.$refs.row && this.$refs.row.length > 0) {
              this.trTrimHeight(this.$refs.row[0].offsetHeight)
            }
          })
        },
        initTrHeight() {
          this.trSetHeight(null)
          this.$nextTick(() => {
            if (this.$refs.form) {
              this.trSetHeight(this.$refs.form.scrollHeight)
            }
          })
        },
        logItems() {
          console.log(this.repeaters)
        },
          async gSM() {
        await this.axios
          .get(
            `departments?take=1000&skip=0`
          )
          .then((res) => {
            this.search.departments = [];
            this.search.departments = res.data.items;
          })
      },
      handleSubmit() {
        if(this.form.id!=null){
          this.updateItem()
        }else{
          this.addNewItem()
        }
      },
      async addNewItem() {
        if (isNaN(this.form.department_id)) {
          this.form.department_id = this.form.department_id["id"];
        }
        const formData = new FormData();
        formData.append('name', this.form.name);
        formData.append('department_id', this.form.department_id);
        formData.append('kafala_no', this.form.kafala_no);
        formData.append('amount', this.form.amount);
        formData.append('date', this.form.date);
        formData.append('is_done', this.form.is_done);
        formData.append('notes', this.form.notes);
        formData.append('file', this.form.file);
        this.repeaters.forEach((kafel, index) => {
          formData.append(`kafels[${index}][id]`, kafel.id);
          formData.append(`kafels[${index}][name]`, kafel.name);
          formData.append(`kafels[${index}][department_id]`, kafel.department.id);
        });

        await this.axios
          .post(`kafel`, formData, {
          onUploadProgress: (progressEvent) => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          },
        }, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((res) => {
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.makeToast(
                "success",
                "تحديث العنصر",
                "تم تحديث العنصر بنجاح ;)"
              );
              this.gS();
            }
            this.precentage = 0;
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't have permission to do this action ;)"
              );
            } else {
              this.errorToast();
            }
            this.precentage = 0;
          });
        this.resetForm(false);
      },

      async updateItem() {
        if (isNaN(this.form.department_id)) {
          this.form.department_id = this.form.department_id["id"];
        }
        const formData = new FormData();
        formData.append('name', this.form.name);
        formData.append('department_id', this.form.department_id);
        formData.append('kafala_no', this.form.kafala_no);
        formData.append('amount', this.form.amount);
        formData.append('date', this.form.date);
        formData.append('is_done', this.form.is_done);
        formData.append('notes', this.form.notes);
        formData.append('file', this.form.file);
        this.repeaters.forEach((kafel, index) => {
          formData.append(`kafels[${index}][id]`, kafel.id);
          formData.append(`kafels[${index}][name]`, kafel.name);
          formData.append(`kafels[${index}][department_id]`, kafel.department.id);
        });
        await this.axios
          .post(`kafel/${this.form.id}`, formData,{
          onUploadProgress: (progressEvent) => {
            this.precentage =
              (progressEvent.loaded / progressEvent.total) * 100;
          },
        }, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then((res) => {
            this.resetForm(false);
            if (res.data.errors) {
              this.errorToast();
            } else {
              this.makeToast(
                "success",
                "تحديث العنصر",
                "تم تحديث العنصر بنجاح ;)"
              );
              this.gS();
            }
            this.precentage = 0;
          })
          .catch((e) => {
            if (e.message.includes("401")) {
              this.makeToast(
                "warning",
                "update failed",
                "you don't have permission to do this action ;)"
              );
            } else {
              this.errorToast();
            }
            this.precentage = 0;
          });
       
      },

      async gS() {
            var department;
            if (isNaN(this.search.department_id)) {
                department = this.search.department_id["id"];
              }
              console.log(this.finishedItems)
          await this.axios
            .get(`kafels?take=${this.perPage}&skip=${this.currentPage - 1}
            &title=${this.search.title}&department=${department}&status=${this.finishedItems}`)
            .then((res) => {
              this.items = [];
              this.totalRows = res.data.totalCount;
              this.items = res.data.items;
            })
            .catch((e) => {
              if (e.message.includes("401")) {
                this.makeToast(
                  "danger",
                  "update failed",
                  "you don't a permision to do this action ;)"
                );
              } else {
                this.errorToast();
              }
            });
        },
      makeToast(variant = null, title = null, body = null) {
          this.$bvToast.toast(body, {
            title: title,
            variant,
            solid: false,
          });
        },
        chechcheck(){
          console.log(this.finishedItems)
        },
      errorToast() {
          this.makeToast(
            "danger",
            "update failed",
            "some thing want wrong, i`m sorry :("
          );
        },
        check() {
          setTimeout(() => this.gS(), 1000);
        },
        async addNewKafalaStatus(){
          this.addNewKafala = !this.addNewKafala;
        },
          resetForm(status){
            this.form.id=null,
            this.form.name=null,
            this.form.department_id=null,
            this.form.kafala_no=null,
            this.form.amount=null,
            this.form.date=null,
            this.form.is_done=null,
            this.form.notes=null, 
            this.form.file=null, 
            this.form.kafels=[],
            this.addNewKafala=status,
            this.repeaters= [{
            id:1,
            name: '',
            department_id: '',
          }]
          },
      shortenDate(date) {
        let newDate = date.split("");
        newDate = newDate.slice(0, 10);
        newDate = newDate.join("");
        return newDate;
      },
      selectFiles(e) {
      this.form.file = "";
      console.log(e.target.files[0]);
      this.form.file = e.target.files[0];
    },
    showPfd(item){
      window
      .open(`${filesUrl}/${item}`, '_blank')
      }
    }
    }
    </script>
